import { isFinite } from 'lodash-es'

import deline from './deline'
import envRaw from './env-raw'
import Emitter from './emitter'
import debugFields from './debug-fields'
import forceResize from './force-resize'

import { onEventPassive } from './on-event'

export default pageScrollProvider()

function pageScrollProvider() {
  const pageScroll = Emitter('pageScroll')
  const supportsPageOffset = isFinite(window.pageXOffset)

  pageScroll.top = Emitter('pageScroll::top')
  pageScroll.left = Emitter('pageScroll::left')

  let lastTop = null
  let lastLeft = null

  onEventPassive(window, 'scroll', handler)

  forceResize.emitter.on(manualTrigger)

  pageScroll.getTop = getTop
  pageScroll.getLeft = getLeft
  pageScroll.manualTrigger = manualTrigger

  return debugFields(pageScroll, {
    _handler: handler,
    _lastScroll: lastScroll,
    _getActualTop: getActualTop,
    _getActualLeft: getActualLeft,
    _supportsPageOffset: supportsPageOffset
  })

  function lastScroll() {
    return {
      lastTop,
      lastLeft
    }
  }

  function getTop() {
    return lastTop !== null ? lastTop : getActualTop()
  }

  function getLeft() {
    return lastLeft !== null ? lastLeft : getActualLeft()
  }

  function getActualTop() {
    if (supportsPageOffset) {
      return Math.round(window.pageYOffset)
    } else {
      return Math.round(document.documentElement.scrollTop || document.body.scrollTop || 0)
    }
  }

  function getActualLeft() {
    if (supportsPageOffset) {
      return Math.round(window.pageXOffset)
    } else {
      return Math.round(document.documentElement.scrollLeft || document.body.scrollLeft || 0)
    }
  }

  function manualTrigger() {
    lastTop = null
    lastLeft = null
    handler()
  }

  function handler() {
    const top = getActualTop()
    const left = getActualLeft()

    const topChanged = top !== lastTop
    const leftChanged = left !== lastLeft
    const someChanged = topChanged || leftChanged

    if (topChanged) lastTop = top
    if (leftChanged) lastLeft = left

    if (someChanged) pageScroll.emit(lastLeft, lastTop)
    if (leftChanged) pageScroll.left.emit(lastLeft, lastTop)
    if (topChanged) pageScroll.top.emit(lastLeft, lastTop)

    if (envRaw.showsPageScrollDebug) {
      console.debug(deline(`
        ${Date.now()} !pageScroll
          [${topChanged ? 'T' : '-'}]
          [${leftChanged ? 'L' : '-'}]:
          { top: ${lastTop}, left: ${lastLeft} }`))
    }
  }
}
